import {createAction, props} from "@ngrx/store";
import {EventIdResponseInterface} from "../../interfaces/event.interface";

const eventId = '[EVENT]';

export const eventSaveObjectAction = createAction(`${eventId} OBJECT EVENT Saved`, props<EventIdResponseInterface>());
